// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 496 ? "local-figma-runtime" : chunkId) + "." + {"50":"a43d80c9f888d8861d9d","158":"f997a547353cbffdc95b","281":"f86e7a5fd06c7ba97a4b","496":"eb5d4cb14caaa8f710a9","558":"f3248c23a30819514019","568":"341b6ab8445b6318f068","776":"348614a37996f06c1d79","982":"366d8b40a1b96a707898"}[chunkId] + ".js";
};